import { render, staticRenderFns } from "./VideoRender.vue?vue&type=template&id=1beb587e&scoped=true&"
import script from "./VideoRender.vue?vue&type=script&lang=ts&"
export * from "./VideoRender.vue?vue&type=script&lang=ts&"
import style0 from "./VideoRender.vue?vue&type=style&index=0&id=1beb587e&scoped=true&lang=scss&"
import style1 from "./VideoRender.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb587e",
  null
  
)

export default component.exports